const isModeDev = true;

/**
 * Function check number of record to download
 * whether number of download over max of record number to download
 * @dateOption {Datetime} - period to search include start date & end date
 * @metricItem {Array} - metric item list
 * @selectedTargets {Array} - selected targets to compare
 **/
const numberOfDownloadFunc = (dateOption, countSelectedObject = 1, countSelectedTargets = 0) => {
  let checkDownloadLimited = false,
    numberOfLimited,
    numberOfDownload;
  const moment = require('moment');
  const { startDate, endDate } = dateOption;
  let period = moment(endDate, 'YYYYMMDDHHmm').diff(moment(startDate, 'YYYYMMDDHHmm'), 'minutes');
  numberOfLimited = Number(process.env.VUE_APP_DOWNLOAD_LIMITED || 65536);
  numberOfDownload = Number(countSelectedTargets * countSelectedObject * period);
  checkDownloadLimited = numberOfDownload > numberOfLimited;
  return { checkDownloadLimited, numberOfDownload, numberOfLimited };
};

export { isModeDev, numberOfDownloadFunc };
